import { FileButtonInput } from "@marketplace/shared/ui";
import { Anchor, ConditionalRendering, Input, Text } from "@marketplace/ui";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { BASE_MEDIA_URL } from "@/constants";

import type { CrmProductFormSchema } from "../../hooks/schemas/use-crm-product-form-schema";

type CrmProductMediaProps = {
  isPending: boolean;
  handleMediaFileChange: (file: File | null) => Promise<void>;
  isMediaPresignedLoading: boolean;
};

export const CrmProductMedia = ({
  isPending,
  handleMediaFileChange,
  isMediaPresignedLoading
}: CrmProductMediaProps) => {
  const { t } = useTranslation("product", {
    keyPrefix: "integrationProductListPage.crmModal"
  });

  const {
    control,
    watch,
    formState: { errors }
  } = useFormContext<CrmProductFormSchema>();

  const currentMediaUrl = watch("media_url");
  const currentMediaFile = watch("media_file");

  return (
    <Controller
      name="media_file"
      control={control}
      render={({ field }) => (
        <Input.Wrapper
          label={t("labels.mediaUrl")}
          error={errors.media_file?.message?.toString()}
        >
          <div className="flex flex-col gap-1">
            <div className="flex gap-x-2 items-center">
              <FileButtonInput
                fileValue={field.value}
                onChange={handleMediaFileChange}
                deleteFile={() => field.onChange(undefined)}
                disabled={isPending}
                loading={isMediaPresignedLoading}
              />

              <ConditionalRendering
                condition={!!currentMediaUrl && !currentMediaFile}
              >
                <Anchor
                  href={`${BASE_MEDIA_URL}/${currentMediaUrl}`}
                  target="_blank"
                  className="text-ellipsis block overflow-hidden whitespace-nowrap max-w-full"
                >
                  <Text
                    type="paragraph"
                    size="s"
                    className="text-ellipsis overflow-hidden whitespace-nowrap max-w-full"
                  >
                    {currentMediaUrl?.split("/").pop()}
                  </Text>
                </Anchor>
              </ConditionalRendering>

              <ConditionalRendering
                condition={!currentMediaUrl || !!currentMediaFile}
              >
                <Text
                  type="paragraph"
                  size="s"
                  className="text-fjord-grey-500 line-clamp-1"
                >
                  {field.value ? field.value.name : t("placeholders.mediaUrl")}
                </Text>
              </ConditionalRendering>
            </div>
            <Text
              type="paragraph"
              size="s"
              className="text-fjord-grey-500 mt-1"
            >
              Type format file PDF (Max. 2MB)
            </Text>
          </div>
        </Input.Wrapper>
      )}
    />
  );
};
